import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Data from "../../Assets/Data/Car";
import axios from "axios";
import {
  storeCarData,
  checkSessionExistsInIDB,
} from "../../services/indexDBService";

const postData = createAsyncThunk("postData", async (data, thunkAPI) => {
  const config = {
    method: "post",
    url: "",
    headers: {
      Authorization: "",
      "Content-Type": "",
    },
    data: data,
  };

  const response = await axios(config)
    .then(function (response) {
    })
    .catch(function (error) {
    });
  return response?.data;
});

export const conditionalSetCars = createAsyncThunk(
  "car/conditionalSetCars",
  async (carData, { dispatch, getState }) => {
    const state = getState();
    const sessionId = state.car.sessionId;
    const exists = await checkSessionExistsInIDB(sessionId);
    if (!exists) {
      dispatch(setCars(carData)); // normal setter, which syncs to IndexDB
    } else {
      dispatch(setCars({ data: carData, skipIDB: true })); // update redux only
    }
  }
);

// Async function to save to IndexedDB
const saveToIndexedDB = async (sessionId, carData) => {
  if (!sessionId) return;

  try {
    // Break proxy by serializing and deserializing the carData
    const plainCarData = JSON.parse(JSON.stringify(carData));

    await storeCarData(sessionId, plainCarData);
  } catch (error) {
    console.error("Failed to save car data to IndexedDB:", error);
  }
};

// Set initial state
const initialState = {
  data: Data,
  validation: [],
  count: 1,
  retake: false,
  checkCount: 14,
  uploaded: false,
  sms: false,
  sessionId: null, // Add sessionId field
};

export const carSlice = createSlice({
  name: "car",
  initialState,
  reducers: {
    setSessionId: (state, action) => {
      state.sessionId = action.payload;
    },
    setCars: (state, action) => {
      let data;
      let skipIDB = false;
      if (
        typeof action.payload === "object" &&
        !Array.isArray(action.payload) &&
        action.payload !== null &&
        "data" in action.payload
      ) {
        data = action.payload.data;
        skipIDB = action.payload.skipIDB;
      } else {
        data = action.payload;
      }

      state.data = data;
      // if (!skipIDB)
      saveToIndexedDB(state.sessionId, state.data);
    },

    carCount: (state, action) => {
      state.count = action.payload
        ? action.payload
        : state.count <= state.checkCount
        ? state.count + 1
        : state.count;
      saveToIndexedDB(state.sessionId, state.data);
    },
    setRetake: (state) => {
      state.retake = true;
      saveToIndexedDB(state.sessionId, state.data);
    },
    setUploaded: (state) => {
      state.uploaded = true;
      //saveToIndexedDB(state.sessionId, state.data);
    },
    setSendSMS: (state) => {
      state.sms = true;
      saveToIndexedDB(state.sessionId, state.data);
    },
    carCountLimit: (state, action) => {
      state.count = action.payload;
      saveToIndexedDB(state.sessionId, state.data);
    },
    setCheckCount: (state, action) => {
      state.checkCount = action.payload;
      //saveToIndexedDB(state.sessionId, state.data);
    },
    resetCarState: () => {
      return {
        ...initialState,
        data: Array.isArray(Data) ? [...Data] : Data,
      };
    },
    resetCarStateInitial: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(postData.pending, (state, action) => {});
    builder.addCase(postData.fulfilled, (state, action) => {});
    builder.addCase(postData.rejected, (state, action) => {});
    builder.addCase("RESET_APP_STATE", () => {
      return initialState;
    });
  },
});

export const {
  setSessionId,
  setCars,
  carCount,
  setRetake,
  setCheckCount,
  setUploaded,
  setSendSMS,
  resetCarState,
  resetCarStateInitial,
  carCountLimit,
} = carSlice.actions;

export default carSlice.reducer;
